import faIR from "./locales/fa-IR";
import { f_tool_scale_get } from "./utils/scale";

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
    //console.log("access.ts: ", initialState);
    const { currentUser } = initialState ?? {};

    var v_access=currentUser?.access||"120,";
    var v_index =1;
    var v_access_curr ="";
    var v_result ="{"
    do{
      v_access_curr =f_tool_scale_get(v_access,v_index);
      if(v_access_curr ==""){
        break;
      }
      v_result =v_result + "\"" +v_access_curr+"\":true,";
      v_index =v_index +1;
      if(v_index>500){//防止死循环
        break;
      }
    }while(true);
    v_result =v_result +" \"seeCounter\":true}";

    //console.log("v_result before return: ", v_result+"---"+v_index);
    return JSON.parse(v_result);
    return {
      //canAdmin:currentUser && currentUser.access === 'admin',
      //canAdmin:true, 
      canAdmin:true,
      canlist:true,
    };
}
